import ApprovalCard from '../ntisui/Atoms/ApprovalCard';
import './operator.scss';
import infoIcon from '../../assets/images/infoapprove.png';
import successIcon from '../../assets/images/successapprove.png';
import { useEffect, useState } from 'react';
import { updateData } from '../../api/ApiCommunication';
import { Spinner } from 'react-bootstrap';
import useToastContext from '../App/hooks/useToastContext';

const Operator = () => {
  const addToast = useToastContext();
  const [isLoading, setIsLoading] = useState(true);
  const [isAction, setIsAction] = useState(false);

  //Approval Action API
  const approvalUserAction = () => {
    const body = {
      isApproved:
        window.sessionStorage.getItem('isApproved') === '0' ? false : true,
      subscriberId: window.sessionStorage.getItem('subscriberId'),
    };
    updateData('approveSubscriber', body)
      .then(() => {
        window.sessionStorage.removeItem('isApproved');
        window.sessionStorage.removeItem('subscriberId');
        setIsLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          // The error comes from the API response
          if (error.response.status === 401) {
            // Unauthorized error
            addToast({
              message:
                'Unauthorized: Please check your credentials or Login again',
              action: 'error',
            });
          } else if (
            error.response.data.error[0] ===
            'Subcriber approval action already captured'
          ) {
            // Other error
            setIsLoading(false);
            setIsAction(true);
          } else if (error.response.data) {
            addToast({
              message: 'Something went wrong please try again !',
              action: 'error',
            });
            console.log(error.response.data.error[0]);
          }
        } else {
          // Network or other errors
          console.log('Network Error:', error.message);
          addToast({
            message: 'Something went wrong please try again !',
            action: 'error',
          });
        }
      });
  };

  useEffect(() => {
    if (window.sessionStorage.getItem('isApproved')) {
      approvalUserAction();
    } else {
      setIsAction(true);
      setIsLoading(false);
    }
  }, []);

  return (
    <div className="operator-container">
      {!isLoading && (
        <>
          {!isAction ? (
            <ApprovalCard
              iconSrc={successIcon}
              heading="Subscriber registration"
              content="Subscriber registration approval response submitted successfully."
            />
          ) : (
            <ApprovalCard
              iconSrc={infoIcon}
              heading="Subscriber registration"
              content="Subscriber registration approval response already captured."
            />
          )}
        </>
      )}

      {isLoading && (
        <div className="d-flex justify-content-center text-center">
          <Spinner
            className="spinner-border"
            animation="border"
            role="status"
          />
        </div>
      )}
    </div>
  );
};

export default Operator;
